export enum EDataSources {
    YAPILY = "Yapily",
    FL4 = "FastLink4",
}
